'use client';

import { useTabPanel } from '../../context';
import React, { Suspense } from 'react';

interface TabPanelProps {
  tabSetId: string;
  children: React.ReactNode;
  index: number;
  className?: string;
  fallback?: React.ReactNode;
}

const TabPanel = ({
  tabSetId,
  index,
  children,
  className,
  fallback = (
    <div className="w-full h-full flex items-center justify-center">
      <div className="animate-pulse text-neutral-600">Loading...</div>
    </div>
  ),
}: TabPanelProps) => {
  const { isActive } = useTabPanel(tabSetId, index);

  if (!isActive) return null;

  return (
    <div className={`text-gray-800 transition-all duration-300 ${className}`}>
      <Suspense fallback={fallback}>{children}</Suspense>
    </div>
  );
};

export default TabPanel;
